<template>
  <div class="foot">
    <h1>---footer---</h1>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>


<style>
.foot{
    bottom: 0px;
    /* position: absolute; */
    height: 80px;
    background-color: #1d466b;
    width: 100%;
    color: #f1f1f1;

}
</style>